import React from "react";
import { FaFacebookF, FaGithub, FaLinkedinIn, FaWhatsapp } from "react-icons/fa";

const socialLinks = [
  {
    name: "Facebook",
    href: "https://www.facebook.com/share/1AV4jYQo53/?mibextid=wwXIfr",
    icon: <FaFacebookF />,
  },
  {
    name: "GitHub",
    href: "https://github.com/Abdullahi23-H",
    icon: <FaGithub />,
  },
  {
    name: "LinkedIn",
    href: "https://www.linkedin.com/in/abdullhi-kediye-a05552373",
    icon: <FaLinkedinIn />,
  },
  {
    name: "WhatsApp",
    href: "https://wa.me/447933080818",
    icon: <FaWhatsapp />,
  },
];

const Footer = () => {
  return (
    <footer>
      <div className="footer-social">
        {socialLinks.map((link) => (
          <a
            key={link.name}
            href={link.href}
            target="_blank"
            rel="noopener noreferrer"
            aria-label={link.name}
            className="footer-social-link"
          >
            {link.icon}
          </a>
        ))}
      </div>
      <p>&copy; Abdullahi 2026. All rights reserved.</p>
    </footer>
  );
};

export default Footer;
